// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA4R2Zo5HbbyXxX-xEX4Tpxbq-InkCboQw",
  authDomain: "ecommercedatabaseproject6.firebaseapp.com",
  projectId: "ecommercedatabaseproject6",
  storageBucket: "ecommercedatabaseproject6.firebasestorage.app",
  messagingSenderId: "608491700791",
  appId: "1:608491700791:web:08bf72454d591bbc00f5b2"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;